import {TranslationObject} from '@colonist/i18n'
import {UIPatchNotes} from '../../../../shared/scripts/patch_notes/UIPatchNotes'
import {UICheckoutPageController} from '../../../../shared/scripts/ui_checkout/UICheckoutPageController'
import {UIMFullscreenPageView} from '../../ui_page/UIMFullscreenPageView'
import {UIChampionship25Controller} from '../../../../shared/scripts/ui_cc/UIChampionship25Controller'

export class UIMSingletonPageView extends UIMFullscreenPageView {
    readonly pathname: string

    constructor(pathname: string, backButtonAction?: () => void) {
        super(UIMSingletonPageView.getTitleFromPageType(pathname), pathname, backButtonAction)
        this.pathname = pathname
        this.addQueryParameters()
        void this.setContent()
    }

    static getTitleFromPageType(pathname: string): TranslationObject {
        if(pathname.includes('/faq')) return {key: 'strings:homePage.footer.faq'}
        if(pathname.includes('/terms')) return {key: 'strings:homePage.singletonPages.terms'}
        if(pathname.includes('/about')) return {key: 'strings:homePage.footer.about'}
        if(pathname.includes('/careers')) return {key: 'strings:homePage.footer.careers'}
        if(pathname.includes('/values')) return {key: 'strings:homePage.singletonPages.values'}
        if(pathname.includes('/checkout')) return {key: 'strings:homePage.singletonPages.checkout'}
        if(pathname.includes('/community')) return {key: 'strings:homePage.footer.community'}
        if(pathname.includes('/patch-notes')) return {key: 'strings:homePage.singletonPages.patchNotes'}
        if(pathname.includes('/press-kit')) return {key: 'strings:homePage.singletonPages.pressKit'}
        if(pathname.includes('/refund-policy')) return {key: 'strings:homePage.singletonPages.refundPolicy'}
        if(pathname.includes('/privacy-policy')) return {key: 'strings:homePage.singletonPages.privacyPolicy'}
        if(pathname.includes('/championship2025')) return {key: 'strings:homePage.footer.championship25'}
        return {key: 'strings:colonistCommon.utils.emptyString'}
    }

    buildView() {
        void this.setContent()
    }

    private async setContent() {
        const url = `/singleton${this.pathname}`
        const response = await fetch(url)
        const content = await response.text()
        // eslint-disable-next-line no-restricted-syntax
        this.body.innerHTML = content
        this.loadController()
    }

    private addQueryParameters() {
        const url = window.location.origin + this.pathname
        const parsedUrl = new URL(url)

        window.history.pushState(undefined, '', parsedUrl.search)
    }

    private loadController() {
        if(this.pathname.includes('/checkout')) {
            new UICheckoutPageController()
        } else if(this.pathname.includes('/patch-notes')) {
            new UIPatchNotes(null)
        } else if(this.pathname.includes('/championship2025')) {
            new UIChampionship25Controller()
        }
    }
}
